<template>
  <v-card flat>
    <ProviderBookCommonTheory
      v-if="hasCourses"
      :professionId="profession.id"
      :courseId="professionCourse.id"
      :has-assignments="get(profession, 'distanceEducationProvider.features.hasAssignments',false)"
    >
    </ProviderBookCommonTheory>
    <ProviderBookElements
      :professionId="profession.id"
      :profession-course="professionCourse"
    />
  </v-card>
</template>

<script>
import ProviderBookCommonTheory from '@/components/admin/book/ProviderBookCommonTheory'
import ProviderBookElements from '@/components/admin/book/ProviderBookElements'
import get from 'lodash/get'
// @group Ebook
// Styled ProviderBook component
export default {
  name: 'ProviderBook',

  props: {
    professionCourse: Object,
    profession: Object,
    hasCourses: Boolean
  },

  components: {
    ProviderBookCommonTheory,
    ProviderBookElements
  },

  methods: {
    get
  }
}
</script>

<style lang="scss" scoped>
</style>